<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Editar Permissão</h4>
			<form #f="ngForm" name="form" novalidate>
				<div class="p-fluid p-formgrid grid" *ngIf="loadingPermissao">
					<div class="field col-12 md:col-12">
						<p-divider></p-divider>
					</div>
				</div>
				<div class="flex justify-content-center" *ngIf="loadingPermissao">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<div class="formgroup" *ngIf="permissao">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="descricaoExibicao">Descrição Exibição</label>
							<input type="text" pInputText placeholder="Insira a descrição" name="descricaoExibicao"
								ngModel #descricaoExibicao="ngModel" required [(ngModel)]="permissao.descricao" />
							<div *ngIf="descricaoExibicao.hasError('required') && descricaoExibicao.touched"
								class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="permissaoBanco">Descrição no Banco</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Insira a descrição" name="permissaoBanco" ngModel #permissaoBanco="ngModel"
								required [(ngModel)]="permissao.permissao" />
							<div *ngIf="permissaoBanco.hasError('required') && permissaoBanco.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="tipo">Tipo</label>
							<p-dropdown [options]="tipos" [filter]="true" emptyFilterMessage="Nenhum registro"
								name="tipo" [(ngModel)]="permissao.tipo"></p-dropdown>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="categoriaPermissao">Categoria Permissao</label>
							<p-dropdown [options]="categoriasPermissoes" optionLabel="descricao" [filter]="true"
								emptyFilterMessage="Nenhum registro" [(ngModel)]="permissao.categoriaPermissao"
								name="categoriaPermissao"></p-dropdown>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Atualizar" (click)="atualizar()"
								class="p-button-success mt-5" [disabled]="!f.valid"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">
						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/permissao"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>